export default __webpack_public_path__ + "static/instagram-g425d4841f_640-762da0e69b1f0a96c340aafb9b4ea89e.png";